module.exports = __webpack_public_path__ + "static/contactBG-0c5d0bd9c57fe052d931d66d4460baff.png";